import createIcon from '../../createIcon';

/**
 * @component @name AutoFixNormal
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjIuNTAxNSAxLjQ5ODA1TDIwLjAwMTUgMi44OTgwNUwxNy41MDE1IDEuNDk4MDVMMTguOTAxNSAzLjk5ODA1TDE3LjUwMTUgNi40OTgwNUwyMC4wMDE1IDUuMDk4MDVMMjIuNTAxNSA2LjQ5ODA1TDIxLjEwMTUgMy45OTgwNUwyMi41MDE1IDEuNDk4MDVaTTE0Ljg3MTUgNi43ODgwNUMxNC40ODE1IDYuMzk4MDUgMTMuODUxNSA2LjM5ODA1IDEzLjQ2MTUgNi43ODgwNUwxLjc5MTUyIDE4LjQ1OEMxLjQwMTUyIDE4Ljg0OCAxLjQwMTUyIDE5LjQ3OCAxLjc5MTUyIDE5Ljg2OEw0LjEzMTUyIDIyLjIwOEM0LjUyMTUyIDIyLjU5OCA1LjE1MTUyIDIyLjU5OCA1LjU0MTUyIDIyLjIwOEwxNy4yMDE1IDEwLjU0OEMxNy41OTE1IDEwLjE1OCAxNy41OTE1IDkuNTI4MDUgMTcuMjAxNSA5LjEzODA1TDE0Ljg3MTUgNi43ODgwNVpNMTMuODQxNSAxMi4yNzhMMTEuNzIxNSAxMC4xNThMMTQuMTYxNSA3LjcxODA1TDE2LjI4MTUgOS44MzgwNUwxMy44NDE1IDEyLjI3OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AutoFixNormal = createIcon('AutoFixNormal', [
  [
    'path',
    {
      d: 'M22.5015 1.49805L20.0015 2.89805L17.5015 1.49805L18.9015 3.99805L17.5015 6.49805L20.0015 5.09805L22.5015 6.49805L21.1015 3.99805L22.5015 1.49805ZM14.8715 6.78805C14.4815 6.39805 13.8515 6.39805 13.4615 6.78805L1.79152 18.458C1.40152 18.848 1.40152 19.478 1.79152 19.868L4.13152 22.208C4.52152 22.598 5.15152 22.598 5.54152 22.208L17.2015 10.548C17.5915 10.158 17.5915 9.52805 17.2015 9.13805L14.8715 6.78805ZM13.8415 12.278L11.7215 10.158L14.1615 7.71805L16.2815 9.83805L13.8415 12.278Z',
      key: '1ofjyx',
    },
  ],
]);

export default AutoFixNormal;
